import { useState } from 'react'
import { Item } from './components/select/types'

export function useFilter<T>(choicesMap: (x: T[]) => (Item[] | string[])) {
    let [items, setItems] = useState<T[]>([])
    let [choices, setChoices] = useState<Item[] | string[]>([])
    let [selectedChoices, setSelectedChoices] = useState<string[]>([])

    let values = (): string[] => {
        if (selectedChoices.length !== 0)
            return selectedChoices
        else
            return choices.map(x => typeof x === 'string' ? x : x.value)
    }

    let setItemsAndChoices = (items: T[], itemsFilter?: (x: T) => boolean) => {
        setItems(items)
        
        let filteredItems =  !!itemsFilter ? items.filter(itemsFilter) : items
        setChoices(choicesMap(filteredItems))
    }
    
    let setChoicesFromFilteredItems = (itemFilter: (value: T) => boolean) => { 
        let newChoices = choicesMap(items.filter(itemFilter))
        setChoices(newChoices)
        
        let newSelectedChoices = selectedChoices.filter(x => 
            newChoices.some((choice: Item | string )=> (typeof choice === 'string' ? choice : choice.value) === x))
        if (newSelectedChoices.length < selectedChoices.length){
            if (newSelectedChoices.length === 0 && newChoices.length === 1) {
                newSelectedChoices = [typeof newChoices[0] === 'string' ? newChoices[0] : newChoices[0].value]
            }
            setSelectedChoices(newSelectedChoices)  
        } 
    }

    let firstChoice = (): string | null => {
        if (items.length < 1)
            return null
        return typeof choices[0] === 'string' ? choices[0] : choices[0].value
    }

    return { items, setItems: setItemsAndChoices, choices, selectedChoices, setSelectedChoices, values, firstChoice, setChoicesFromFilteredItems }
}

export type Filter = ReturnType<typeof useFilter>

type Values<T> = {
    [P in keyof T]: string[]
}

export function mapValues<T extends { [key: string]: Filter }>(obj: T): Values<T> {
    let result = {} as Values<T>

    for (let prop in obj)
        result[prop] = obj[prop].values() as any

    return result
}